import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box, Fade } from '@mui/material'
import Picture from '@v4/components/common/Picture'
import PageMetaData from '@v4/utils/data/PageMetaData'
import withMetaKey from './withMetaKey'
import { useImage } from './Image.hooks'

const Image = props => {
	const [
		{ alt, classes, className, isBackground, src, srcSet, timeout, isServer, children },
		{ handleClick },
	] = useImage(props)

	const content = (
		<Box
			className={clsx(classes.bgImage, className, 'image-box')}
			onClick={handleClick}
			role={isBackground ? 'img' : undefined}
		>
			{!isBackground && src && (
				<Picture className={clsx(classes.image, 'image')} src={src} alt={alt} srcSet={srcSet} />
			)}
			{isBackground && children}
		</Box>
	)
	return isServer ? (
		!!src && content
	) : (
		<Fade in={!!src} mountOnEnter unmountOnExit timeout={timeout}>
			{content}
		</Fade>
	)
}

Image.propTypes = {
	metaData: PropTypes.instanceOf(PageMetaData).isRequired,
	className: PropTypes.string,
	isBackground: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.node,
}

export default memo(withMetaKey(Image))
